export default __webpack_public_path__ + "static/media/viadance_logo.d5e7aef9.png";